import { useMemo } from 'react';

import { AppGameEventResponse, GameEventID } from '@playq/octopus2-liveops';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { gameEventRetrieveQueryKey } from './constants';

export const useGetGameEvent = (
  id?: GameEventID,
  version?: number,
  options?: IUseQueryOptionsExtended<AppGameEventResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => gameEventRetrieveQueryKey.concat(id, version), [id, version]);
  const res = useEitherQuery(keys, () => services2.appGameEventsService.retrieve(id as GameEventID, version), {
    ...options,
    enabled: options?.enabled !== false && id !== undefined,
  });

  return {
    ...res,
    tags: keys,
  };
};
